import { render } from "./AgendaCampeonatoEditor.vue?vue&type=template&id=1d053e6c&scoped=true"
import script from "./AgendaCampeonatoEditor.vue?vue&type=script&lang=js"
export * from "./AgendaCampeonatoEditor.vue?vue&type=script&lang=js"

import "./AgendaCampeonatoEditor.vue?vue&type=style&index=0&id=1d053e6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d053e6c"]])

export default __exports__